import { FormControl } from './FormControl';
import { FormErrorMessage } from './FormErrorMessage';
import { FormHelperText } from './FormHelperText';
import { FormLabel } from './FormLabel';

export const Form = {
  Control: FormControl,
  Label: FormLabel,
  HelperText: FormHelperText,
  ErrorMessage: FormErrorMessage,
};
